// extracted by mini-css-extract-plugin
module.exports = {"questionTitle":"OpenEnded_questionTitle__3k88R","error":"OpenEnded_error__3SmQm","text":"OpenEnded_text__2y4NT"};